import {
    PaginationState,
    createColumnHelper,
    flexRender,
    getCoreRowModel,
    getSortedRowModel,
    SortingState,
    useReactTable,
} from "@tanstack/react-table";
import Card from "components/card";
import DivLoader from "components/divloader/DivLoader";
import React, { useEffect, useState } from "react";
import Pagination from "components/pagination";
import { BsArrowDown, BsArrowUp, BsInfoCircleFill } from "react-icons/bs";
import { RiArrowUpDownFill } from "react-icons/ri";
import { PayoutRowObj } from "..";
import moment from "moment";
import ShortTruncateCopy from "components/common/ShortTruncateCopy";
import { AiFillMinusCircle, AiFillPlusCircle } from "react-icons/ai";
import Searchbox from "components/fields/Searchbox";
import StatusRender from "views/admin/payments/components/StatusRender";
import InfoModal from "./infoModal";
import CustomToolTip from "components/tooltips";
import { getImage } from "utils/commonFunction";

function PayoutList(props:{
    tableData: any;
    fetchPayouts: () => void;
    onValueChange: (value: string) => void;
    roleData?: any;
    isLoading: boolean;
    page: number;
    setPage: any;
    totalpage: number;
    totalItems: number;
    currentPage: number;
    pageSize: number;
    setPageSize: any;
    filterData: () => void;
    filter: any;
    setFilter: (e: any) => void;
    setLocalFilters?: (e: any) => void;
    setClearClick: () => void;
    localFilters?: any;
}) { 

    const {filter,setFilter,setClearClick,setLocalFilters,localFilters,filterData,tableData,onValueChange,isLoading,roleData,page,setPage,totalpage,totalItems,currentPage,pageSize,setPageSize,fetchPayouts} = props;
    let defaultData = tableData;
    const [searchVal, setSearchVal] = useState<any>("");
    
    const [{ pageIndex }, setPagination] = React.useState<PaginationState>({
        pageIndex: 0,
        pageSize,
    });

    const [expandedRow, setExpandedRow] = useState<string | null>(null);
    const pagination = React.useMemo(() => ({
        pageIndex,
        pageSize,
    }), [pageIndex, pageSize],);

    const handleExpand = (rowId : any) => {
        setExpandedRow(expandedRow === rowId ? null : rowId);
    };

    const approveBatch = (id : any) => {

    }

    const columns = [
        columnHelper.accessor("createdAt", {
            id: "createdAt",
            header: () => (
                <p className="text-sm font-bold text-gray-900 dark:text-white">Created Date</p>
            ),
            cell: (info : any) => {
                const rawDate = info.getValue();
                const formattedDate = moment(rawDate).format("YYYY-MM-DD HH:mm:ss");
        
                return (
                    <p
                    className="text-sm font-bold text-navy-700 dark:text-white flex items-center gap-1 cursor-pointer"
                    onClick={() =>
                        handleExpand(info?.row?.original?.id)
                    }
                    >
                    
                        {expandedRow === info?.row?.original?.id ? (
                        <AiFillMinusCircle className="w-5 h-5 text-navy-700 dark:text-white" />
                        ) : (
                        <AiFillPlusCircle className="w-5 h-5 text-navy-700 dark:text-white" />
                        )}
                    
                    {formattedDate}
                    </p>
                );
            },  
            size: 200, 
            minSize: 200,
            maxSize: 300,  
        }),
        columnHelper.accessor("batchId", {
            id: "clientId",
            header: () => (
                <p className="text-sm font-bold text-gray-900 dark:text-white">Batch ID</p>
            ),
            cell: (info) => {
                return (
                    <>
                        <p className="text-sm font-bold uppercase text-navy-700 dark:text-white">
                            <ShortTruncateCopy info={info?.getValue()} showCopy={true} />
                        </p>
                    </>
                );
            },
        }),
        columnHelper.accessor("clientName", {
            id: "clientName",
            header: () => (
                <p className="text-sm font-bold text-gray-900 dark:text-white">Client Name</p>
            ),
            cell: (info) => {
                return (
                    <>
                        <div className="flex items-center">
                            <p className="text-sm font-bold text-navy-700 dark:text-white">
                                {info?.getValue()}
                            </p>
                        </div>
                    </>
                );
            },
        }),
        columnHelper.accessor("totalTransactions", {
            id: "totalTransactions",
            header: () => (
              <p className="text-sm font-bold text-gray-900 dark:text-white">TX #</p>
            ),
            cell: (info: any) => {
                return <>
                    <div className="flex items-center">
                        <p className="text-sm font-bold text-navy-700 dark:text-white">
                            {info?.getValue()}
                        </p>
                    </div>
                </>
            },
        }),
        columnHelper.accessor("gatewayName", {
            id: "gatewayName",
            header: () => (
              <p className="text-sm font-bold text-gray-900 dark:text-white">

                GATEWAY {roleData[0]?.payout?.value?.payout_show_method_name ? "NAME" : "HASH ID"}

              </p>
            ),
            cell: (info: any) => {
                return <>
                    {/* <div className="flex items-center">
                        <p className="text-sm font-bold text-navy-700 dark:text-white">
                            {info?.getValue()}
                        </p>
                    </div> */}
                    <p className="text-sm font-bold uppercase text-navy-700 dark:text-white">
                        <div title={info?.row?.original?.gatewayId}>
                            {!roleData[0]?.payout?.value?.payout_show_method_name ? (
                                <ShortTruncateCopy
                                    info={
                                    info?.row?.original?.gatewayId
                                        ? info?.row?.original?.gatewayId
                                        : "-"
                                    }
                                    showCopy={true}
                                />
                            ) : (
                                <span className="flex items-center ">
                                    <img
                                    style={{ height: "auto", width: "15px" }}
                                    className="h-auto w-20"
                                    src={getImage(info?.getValue())}
                                    alt="Img"
                                    />
                                    <p className="px-2">
                                    {info?.getValue()
                                        ? info?.getValue()
                                        : "-"}
                                    </p>
                                </span>
                            )}
                        </div>
                    </p>
                </>
            },
        }),
        columnHelper.accessor("totalAmount", {
            id: "totalAmount",
            header: () => (
              <p className="text-sm font-bold text-gray-900 dark:text-white">Batch Total</p>
            ),
            cell: (info: any) => {
                return <>
                    <div className="flex items-center">
                        <p className="text-sm font-bold text-navy-700 dark:text-white">
                            {Number(info?.getValue() ?? 0).toFixed(2)}
                        </p>
                    </div>
                </>
            },
        })
    ]

    const [sorting, setSorting] = React.useState<SortingState>([]);
    const [data, setData] = React.useState(() => [...defaultData]);

    useEffect(() => {    
        const processedData = tableData.map((item: any) => {
            return {
                ...item,
            };
        });
        console.log(processedData)
        setData(processedData);
    }, [tableData]);

    const table = useReactTable({
        data,
        columns:columns,
        state: {
        pagination,
        sorting,
        },
        onPaginationChange: setPagination,
        onSortingChange: setSorting,
        getCoreRowModel: getCoreRowModel(),
        getSortedRowModel: getSortedRowModel(),
        debugTable: true,
    });

    const handleValueChange = (e: any) => {
        onValueChange(e);
        setSearchVal(e);
    };

    const findLastErrorMessage = (obj: any): string | null => {
        const errorKeys = [
            "errorMessage",
            "message",
            "decline_reason",
            "error_message",
            "failure_message",
            "failure_code",
            "",
        ];
        let lastValue: string | null = null;

        const search = (data: any): void => {
            if (!data || typeof data !== "object") return;
            for (const key of Object.keys(data)) {
            if (errorKeys.includes(key) && key !== "_content") {
                lastValue = data[key];
            }
            if (typeof data[key] === "object") {
                search(data[key]);
            }
            if (key === "_content" && typeof data[key] === "string") {
                try {
                const parsedContent = JSON.parse(data[key]);
                if (parsedContent.decline_reason) {
                    lastValue = parsedContent.decline_reason;
                } else {
                    for (const parsedKey of Object.keys(parsedContent)) {
                    if (errorKeys.includes(parsedKey)) {
                        lastValue = parsedContent[parsedKey];
                    }
                    }
                }
                } catch {}
            }
            }
        };

        search(obj);
        return lastValue;
    };

    const parsePythonJSON = (str: string): any[] | Record<string, any> => {
        try {
            return JSON.parse(
            str
                .replace(/\bNone\b/g, "null")
                .replace(/\bFalse\b/g, "false")
                .replace(/\bTrue\b/g, "true")
                .replace(/([{,]\s*)'([^']+)'\s*:/g, '$1"$2":') // keys
                .replace(/:\s*'([^']*)'/g, ': "$1"') // values
            );
        } catch (e) {
            console.error("Failed to parse Python JSON", e, str);
            return [];
        }
    };

    return (
        <Card extra={"w-full h-full sm:overflow-auto px-6"}>
            <header className="relative flex items-center justify-between pt-5 flex-wrap">
                <div className="block w-full justify-between gap-5 md:flex lg:flex">
                    <div className="flex items-center gap-5">
                        <div className="text-xl font-bold text-navy-700 dark:text-white">
                        Batch Payouts
                        </div>
                    </div>
                    <div className="flex flex-wrap justify-around gap-2 md:pe-[0px] lg:pe-[0px]">
                        <Searchbox onSearch={handleValueChange} />
                    </div>
                </div>
            </header>
            <div className="mt-4  overflow-x-auto scrollbar scrollbar-track-gray-100 scrollbar-thumb-gray-300 scrollbar-track-rounded-full scrollbar-thumb-rounded-xl scrollbar-h-1.5 relative overflow-x-auto shadow-md sm:rounded-lg">
            {props.isLoading ? (
                <DivLoader className="m-5 h-6 w-6 border-indigo-500" />
            ) : (
                <table className="w-full w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400 ">
                    <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400 ">
                        {table.getHeaderGroups().map((headerGroup) => (
                            <tr key={headerGroup.id} className="">
                                {headerGroup.headers.map((header) => {
                                    return (
                                        <th
                                            key={header.id}
                                            colSpan={header.colSpan}
                                            onClick={header.column.getCanSort() ? header.column.getToggleSortingHandler() : undefined}
                                            className={`border-b-[1px] border-gray-200 pb-2 pr-4 pt-4 text-start p-2 ${header.column.getCanSort() ? 'cursor-pointer' : ''}`}
                                        >
                                            <div className="flex items-center text-xs text-gray-200">
                                            {flexRender(header.column.columnDef.header, header.getContext())}
                                            {header.column.getCanSort() && (
                                                <span className="ml-2">
                                                    {header.column.getIsSorted() === "asc" ? (
                                                    <BsArrowUp size={14} className="text-gray-900"/>
                                                    ) : header.column.getIsSorted() === "desc" ? (
                                                    <BsArrowDown size={14} className="text-gray-900"/>
                                                    ) : (
                                                    <RiArrowUpDownFill size={14} className="text-gray-900"/>
                                                    )}
                                                </span>
                                            )}
                                            </div>
                                        </th>
                                    )
                                })}
                            </tr>
                        ))}
                    </thead>
                    <tbody >
                    {(table.getRowModel().rows?.length > 0) ? table.getRowModel().rows.map((row) => {
                        return (
                            <React.Fragment key={row.id}>
                                <tr key={row.id} className="bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600 ">
                                    {row.getVisibleCells().map((cell) => {
                                        return (
                                        <td
                                            key={cell.id}
                                            className="min-w-[150px] border-white/0 py-3  pr-4 p-2 font-bold text-gray-900"
                                        >
                                            {flexRender(
                                            cell.column.columnDef.cell,
                                            cell.getContext()
                                            )}
                                        </td>
                                        );
                                    })}
                                </tr>
                                {expandedRow === row.original.id && (
                                    <tr className="bg-gray-100">
                                        <td colSpan={columns.length} className="p-4 border">
                                            <div className="space-y-2">
                                            <>
                                            <h4 className="font-bold text-navy-700">Transactions</h4>
                                            {Object.keys(row.original.transactions).length > 0 ? (
                                                <div className="border rounded-lg p-3 bg-white shadow">
                                                    <table className="w-full w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400 ">
                                                        <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400 ">
                                                            <tr>
                                                                <th className="border-b-[1px] border-gray-200 pb-2 pr-4 pt-4 text-start p-2">
                                                                    <div className="items-center justify-between text-xs text-gray-200 ">
                                                                        <p className="text-sm font-bold text-gray-900 dark:text-white">Created At</p>
                                                                    </div>
                                                                </th>
                                                                <th className="border-b-[1px] border-gray-200 pb-2 pr-4 pt-4 text-start p-2">
                                                                    <div className="items-center justify-between text-xs text-gray-200 ">
                                                                        <p className="text-sm font-bold text-gray-900 dark:text-white">Amount</p>
                                                                    </div>
                                                                </th>
                                                                <th className="border-b-[1px] border-gray-200 pb-2 pr-4 pt-4 text-start p-2">
                                                                    <div className="items-center justify-between text-xs text-gray-200 ">
                                                                        <p className="text-sm font-bold text-gray-900 dark:text-white">Transaction ID</p>
                                                                    </div>
                                                                </th>
                                                                <th className="border-b-[1px] border-gray-200 pb-2 pr-4 pt-4 text-start p-2">
                                                                    <div className="items-center justify-between text-xs text-gray-200 ">
                                                                        <p className="text-sm font-bold text-gray-900 dark:text-white">Inernal ID</p>
                                                                    </div>
                                                                </th>
                                                                <th className="border-b-[1px] border-gray-200 pb-2 pr-4 pt-4 text-start p-2">
                                                                    <div className="items-center justify-between text-xs text-gray-200 ">
                                                                        <p className="text-sm font-bold text-gray-900 dark:text-white">Status</p>
                                                                    </div>
                                                                </th>
                                                                {roleData?.[0]?.payout?.value?.view_payout_response_information && (
                                                                    <th className="border-b-[1px] border-gray-200 pb-2 pr-4 pt-4 text-start p-2">
                                                                        <div className="items-center justify-between text-xs text-gray-200 ">
                                                                            <p className="text-sm font-bold text-gray-900 dark:text-white">Action</p>
                                                                        </div>
                                                                    </th>
                                                                )}
                                                            </tr>
                                                        </thead>
                                                        <tbody >
                                                        {Object.entries(row.original.transactions).map(([transactionId, transaction]: [string, any]) => (
                                                            <React.Fragment key={transactionId}>
                                                                <tr key={transactionId}  className="bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600 ">
                                                                    <td className="min-w-[150px] border-white/0 py-3 pr-4 p-2 font-bold text-gray-900">
                                                                        {moment(transaction.createdAt).format("YYYY-MM-DD HH:mm:ss")}
                                                                    </td>
                                                                    <td className="min-w-[150px] border-white/0 py-3 pr-4 p-2 font-bold text-gray-900">
                                                                        {Number(transaction.amount ?? 0).toFixed(2)} {transaction.currency}
                                                                    </td>
                                                                    <td className="min-w-[150px] border-white/0 py-3 pr-4 p-2 font-bold text-gray-900">
                                                                        <ShortTruncateCopy info={transaction.transactionId} showCopy={true} />
                                                                    </td>
                                                                    <td className="min-w-[150px] border-white/0 py-3 pr-4 p-2 font-bold text-gray-900">
                                                                        <ShortTruncateCopy info={transaction.internalId} showCopy={true} />
                                                                    </td>
                                                                    <td className="min-w-[150px] border-white/0 py-3 pr-4 p-2 font-bold text-gray-900">
                                                                        <div className="flex items-center">
                                                                            <div className="flex items-center gap-1.5 text-sm font-bold">
                                                                                <CustomToolTip
                                                                                    content={(() => {
                                                                                        try {
                                                                                            const historyArray = Array.isArray(transaction.paymentHistory)
                                                                                                ? transaction.paymentHistory
                                                                                                : typeof transaction.paymentHistory === "string"
                                                                                                ? parsePythonJSON(transaction.paymentHistory)
                                                                                                : [];
                                                                                            if (historyArray.length === 0) {
                                                                                                return <span>No history available.</span>;
                                                                                            }

                                                                                            return historyArray[0].map((hisData: any, index: any) => {
                                                                                                let errorMessage = "";
                                                                                                if (["DECLINED", "ERRORED", "FAILED"].includes(hisData.status)) {
                                                                                                    const lastError = findLastErrorMessage(transaction.gatewayResponse);
                                                                                                    errorMessage = typeof lastError === "string" ? lastError : "";
                                                                                                }

                                                                                                return (
                                                                                                    <Card className="m-2 shadow" key={index}>
                                                                                                        <div className="border-1 max-w-[70vh] border border-white p-3">
                                                                                                            <p>
                                                                                                                Created at {hisData?.created_at} by API call from [{hisData?.client} - {hisData?.ip}] 
                                                                                                                with status {hisData?.status}
                                                                                                                {["DECLINED", "ERRORED", "FAILED"].includes(hisData?.status) && (
                                                                                                                    <>
                                                                                                                        <br />
                                                                                                                        Reason: {errorMessage || "Reason not mentioned by the gateway"}
                                                                                                                    </>
                                                                                                                )}
                                                                                                            </p>
                                                                                                        </div>
                                                                                                    </Card>
                                                                                                );
                                                                                            });
                                                                                        } catch (err) {
                                                                                            return <span>Error loading history</span>;
                                                                                        }
                                                                                    })()}
                                                                                    trigger={
                                                                                        <button className="flex items-center gap-1.5">
                                                                                            <StatusRender status={transaction.status} value={transaction.status} />
                                                                                        </button>
                                                                                    }
                                                                                    header="Status History"
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                    </td>
                                                                    {/* <td className="min-w-[150px] border-white/0 py-3 pr-4 p-2 font-bold text-gray-900">
                                                                        <div className="flex items-center">
                                                                            <div className="flex items-center gap-1.5 text-sm font-bold">
                                                                                <StatusRender status={transaction.status} value={transaction.status}/>
                                                                            </div>
                                                                        </div>
                                                                    </td> */}
                                                                    {roleData?.[0]?.payout?.value?.view_payout_response_information && (
                                                                        <td className="min-w-[150px] border-white/0 py-3 pr-4 p-2 font-bold text-gray-900">
                                                                            <div className="flex items-center">
                                                                                <InfoModal
                                                                                    info={transaction.gatewayResponse}
                                                                                />
                                                                            </div>
                                                                        </td>
                                                                    )}
                                                                </tr>
                                                            </React.Fragment>
                                                        ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            ):(
                                                <div className="border rounded-lg p-3 bg-white shadow">
                                                    <p className="font-bold text-navy-700 text-center">No transactions available.</p>
                                                </div>
                                            )}
                                            </>
                                            </div>
                                        </td>
                                    </tr>
                                )}
                            </React.Fragment>
                        )
                    }) :
                        <tr>
                            <td colSpan={6} >
                            <p className="text-center p-4" >No records found.</p>
                            </td>
        
                        </tr>
                    }
                    </tbody>
                </table>
            )}
            </div>
            <Pagination
                setPage={setPage}
                page={page}
                totalpage={totalpage}
                currentPage={currentPage}
                pageSize={pageSize}
                setPageSize={setPageSize}
                arraySize={[50, 100, 200]}
            />
        </Card>
    )
}

export default PayoutList;
const columnHelper = createColumnHelper<PayoutRowObj>();
